import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../styles/alert.css";

export const SiteAlert = ({
    caption,
    message,
    accept,
    reject,
    onAccept,
    onReject,
    onClose
}) => {
    return (
        <div className="dark-bg flx-col c-al c-jt">
            <div className="alert-container">
                <div className="alert-top-box flx-rw c-al">
                    <div className="caption-box flx-rw c-al c-jt">{caption}</div>
                    <div className="close-button-box flx-rw c-al c-jt">
                        <button className="tr-btn close-alert" onClick={onClose}>
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                </div>
                <div className="alert-msg-section">{message}</div>
                <div className="alert-buttons flx-rw c-al c-jt">
                    <div
                        className="alert-button accept flx-rw c-al c-jt"
                        onClick={onAccept}
                    >
                        {accept}
                    </div>
                    {reject &&
                        <div
                            className="alert-button reject"
                            onClick={onReject}
                        >
                            {reject}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}